var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfSellCarIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21750",
    "data-name": "\\uADF8\\uB8F9 21750",
    transform: "translate(-692 -1866)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27601",
    "data-name": "\\uC0AC\\uAC01\\uD615 27601",
    width: 40,
    height: 40,
    transform: "translate(692 1866)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21749",
    "data-name": "\\uADF8\\uB8F9 21749",
    transform: "translate(0.01 -6.708)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1225",
    "data-name": "\\uD0C0\\uC6D0 1225",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(696 1878.708)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21392",
    "data-name": "\\uADF8\\uB8F9 21392",
    transform: "translate(695.99 1880.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_27596",
    "data-name": "\\uC0AC\\uAC01\\uD615 27596",
    d: "M2.688,0H29.435a2.687,2.687,0,0,1,2.687,2.687V16.538a2.687,2.687,0,0,1-2.687,2.687H2.688A2.688,2.688,0,0,1,0,16.537V2.688A2.688,2.688,0,0,1,2.688,0Z",
    transform: "translate(0 7.616)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10122",
    "data-name": "\\uD328\\uC2A4 10122",
    d: "M90.444,27.016h.413l-.347-1.937c-.12-.679.141-1.157.673-1.247a.881.881,0,0,1,1.121.8l.37,2.381H93.8l.544-2.359a1.165,1.165,0,0,1,2.241,0l.533,2.359h1.133l.37-2.381a.88.88,0,0,1,1.12-.8c.522.09.783.568.663,1.236l-.36,1.948h.425a.591.591,0,0,1,.664.635.62.62,0,0,1-.664.669h-.653l-.6,3.339a1.287,1.287,0,0,1-1.1,1.113,1.151,1.151,0,0,1-1.294-.913l-.783-3.539H94.883L94.1,31.859a1.15,1.15,0,0,1-1.294.913,1.287,1.287,0,0,1-1.1-1.113L91.1,28.32h-.653a.62.62,0,0,1-.663-.669.591.591,0,0,1,.663-.635m2.688,2.951.37-1.647H92.87Zm2.034-2.951h.577L95.46,25.7Zm2.622,2.94.251-1.636h-.631Z",
    transform: "translate(-79.394 -11.066)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10123",
    "data-name": "\\uD328\\uC2A4 10123",
    d: "M82.925,19.729l23.024-5.251a1.888,1.888,0,0,1,2.091,1.573l.9,3.456",
    transform: "translate(-78.827 -12.137)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10124",
    "data-name": "\\uD328\\uC2A4 10124",
    d: "M81,20.91l12.331-6.017,2.923-1.55a1.852,1.852,0,0,1,1.552.018A2.177,2.177,0,0,1,98.9,14.608l.649,1.815",
    transform: "translate(-79.05 -13.18)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSellCarIcon5);
export default __webpack_public_path__ + "static/media/SelfSellCarIcon5.29afee22a82c790d2668b92d1fd3b13f.svg";
export { ForwardRef as ReactComponent };